import { useEffect, useState } from "react";
import axios from "axios";
import { Megaphone, Check, MessageCircle, LayoutTemplate, Store, Star, Globe2, Pencil } from "lucide-react";
import { API } from "../lib/api";
import { useSite } from "../lib/site";
import BackButton from "../components/BackButton";
import EditPencil from "../components/EditPencil";
import AdvertiseEditor from "../components/AdvertiseEditor";

const ICONS = [LayoutTemplate, Store, Star, Globe2];

export default function Advertise() {
  const { owner, canEdit } = useSite();
  const [d, setD] = useState(null);
  const [edit, setEdit] = useState(false);
  useEffect(() => { document.title = "Advertise With Us | CarSaleMarket.com"; axios.get(`${API}/settings/advertise`).then((r) => setD(r.data)); }, []);
  const num = owner?.whatsapp || "918605593941";
  if (!d) return <div className="pt-28 min-h-screen" data-testid="advertise-page" />;
  const wa = `https://wa.me/${num}?text=${encodeURIComponent(d.wa_text || "ADS")}`;
  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 pt-28 pb-10" data-testid="advertise-page">
      <div className="flex items-center justify-between gap-3 mb-8">
        <BackButton testid="advertise-back" />
        {canEdit && <button onClick={() => setEdit(true)} className="btn-gold !py-1.5 !px-4 text-xs" data-testid="advertise-page-edit-btn"><Pencil className="w-3.5 h-3.5" />Edit this page</button>}
      </div>
      <div className="relative overflow-hidden rounded-3xl border gold-line p-8 sm:p-12 grain bg-[radial-gradient(ellipse_at_top_right,rgba(212,175,55,0.2),transparent_60%)] bg-[#0d0f14]">
        <span className="w-12 h-12 rounded-full flex items-center justify-center mb-4" style={{ background: "var(--gold-grad)" }}><Megaphone className="w-5 h-5 text-black" /></span>
        <h1 className="font-display text-4xl sm:text-5xl leading-tight" data-testid="advertise-heading"><span className="gold-text">{d.heading}</span> <EditPencil section="advertise" testid="advertise-section-edit" className="inline-flex align-top" /></h1>
        {d.tagline && <p className="text-lg font-semibold mt-3" data-testid="advertise-tagline">{d.tagline}</p>}
        {d.intro && <p className="text-gray-400 mt-2 max-w-2xl text-sm whitespace-pre-line" data-testid="advertise-intro">{d.intro}</p>}
        <a href={wa} target="_blank" rel="noopener noreferrer" className="mt-6 inline-flex items-center gap-2 px-6 py-3 rounded-full bg-[#25D366] hover:bg-[#1ebe5a] text-black font-semibold transition-colors" data-testid="advertise-whatsapp-btn"><MessageCircle className="w-4 h-4" />WhatsApp Now: +{num}</a>
        {d.wa_note && <p className="text-[11px] text-gray-500 mt-2">{d.wa_note}</p>}
      </div>
      {d.perks.length > 0 && (
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 mt-8">
          {d.perks.map((p, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <div key={i} className="lux-card p-5 flex flex-col" data-testid={`advertise-perk-${i}`}>
                <Icon className="w-6 h-6 text-[#D4AF37] mb-3" /><p className="font-semibold text-sm">{p.title}</p><p className="text-xs text-gray-400 mt-1 flex-1">{p.desc}</p>
                {p.price && <p className="font-display text-2xl gold-text mt-3" data-testid={`advertise-perk-price-${i}`}>{p.price}</p>}
              </div>
            );
          })}
        </div>
      )}
      {d.who.length > 0 && (
        <div className="lux-card p-6 mt-8">
          <p className="eyebrow !text-[10px] mb-3">Perfect for</p>
          <ul className="grid sm:grid-cols-2 lg:grid-cols-3 gap-2">{d.who.map((x, i) => <li key={i} className="flex items-center gap-2 text-sm"><Check className="w-4 h-4 text-[#D4AF37]" />{x}</li>)}</ul>
        </div>
      )}
      {edit && <AdvertiseEditor value={d} onClose={() => setEdit(false)} onSaved={setD} />}
    </div>
  );
}
